import { Component, Vue } from "vue-property-decorator";

// 如果要啟用 PerfectScrollbar，需要引入它並在 Component 裝飾器中註冊
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';

@Component({
  // components: { VuePerfectScrollbar },
})
export class SidebarNav extends Vue {
  /**
   * 檢查是否存在預設插槽內容
   * 使用 getter 作為計算屬性
   */
  get hasSlotDefault(): boolean {
    // 注意：在 Vue 2 中，$slots 不具備響應性，
    // 但對於初始化渲染判斷通常是足夠的。
    return !!this.$slots.default;
  }

  /**
   * Perfect Scrollbar 的設定
   * (目前未啟用，保留供未來使用)
   * 使用 getter 可以讓模板中直接使用 psSettings 而不是 psSettings()
   */
  get psSettings(): object {
    // 需要確保在瀏覽器環境下執行
    if (typeof document === 'undefined') return {};

    const html = document.querySelector("html");
    if (html == null) return {};

    // 獲取計算後的樣式
    const style = window.getComputedStyle(html);

    return {
      maxScrollbarLength: 200,
      minScrollbarLength: 40,
      suppressScrollX: style.direction !== "rtl",
      wheelPropagation: false,
      interceptRailY: (styles: any) => ({ ...styles, height: 0 }),
    };
  }

  /**
   * 捲動事件處理器
   * (目前未啟用，保留供未來使用)
   */
  scrollHandle(evt: any) {
    // console.log(evt)
  }
}
export default SidebarNav;